import { render, staticRenderFns } from "./Prescriptions.vue?vue&type=template&id=5e1e1876&scoped=true"
import script from "./Prescriptions.vue?vue&type=script&lang=js"
export * from "./Prescriptions.vue?vue&type=script&lang=js"
import style0 from "./Prescriptions.vue?vue&type=style&index=0&id=5e1e1876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1e1876",
  null
  
)

export default component.exports